module.exports = __webpack_public_path__ + "static/media/lonelypop_game-05-min.c3029085.png";